import { Button } from '@/shared/components/ui/button';
import { Dialog } from '@/shared/components/ui/dialog';
import { PlusCircle } from 'lucide-react';
import { CreatePayoutAccountForm } from './create-payout-account-form';
import { PayoutMethod } from '@/types/api/payout-account';
import { useSelectBankAccount } from '../hooks/use-select-bank-account';
import { useEffect, useState } from 'react';
import { useCreatePayoutAccount } from '../api/create-payout-account';

export function CreatePayoutAccount() {
  const result = useSelectBankAccount();
  // Only the bank's result opens the dialog; `clear` is a function and always truthy
  const isBackFromBank = Boolean(result.id || result.errorCode || result.errorMessage);
  const [open, setOpen] = useState(isBackFromBank);
  const mutation = useCreatePayoutAccount({ mutationConfig: { onSuccess: () => setOpen(false) } });

  useEffect(() => {
    if (isBackFromBank) {
      setOpen(true);
    }
  }, []);

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
      title="Lägg till utbetalningskonto"
      trigger={
        <Button>
          <PlusCircle className="hidden md:block" />
          <span>Lägg till</span>
        </Button>
      }
    >
      <CreatePayoutAccountForm
        // Back from the bank's account selection: continue with bank transfer, otherwise start on Swish
        defaultValues={
          result.id || result.errorCode
            ? { method: PayoutMethod.BankTransfer, selectionId: result.id ?? '' }
            : { method: PayoutMethod.Swish, swishNumber: '' }
        }
        onSubmit={async (data) => await mutation.mutateAsync({ data })}
      />
    </Dialog>
  );
}
